import { msg } from "@omegagrid/localize";
import { NodeSource, TreeAdapter, TreeAdapterParams, TreeOptions, TreeSource } from "@omegagrid/tree";
import rp from "@reporting/rp-app-host";
import { ModuleCode } from "@reporting/rp-types/accounting";

export class DimTreeAdapter extends TreeAdapter {

	private branches = new Map<string, NodeSource[]>();
	public accounting: number;
	public years: number[] = [];

	constructor(
		private module: ModuleCode,
		private dimNum: string,
		private options?: Partial<TreeOptions>
	) { super() }

	reset() {
		this.branches.clear();
	}

	async getTree(params: TreeAdapterParams): Promise<TreeSource> {
		if (this.module == 'A' && this.dimNum == 'IR') {
			return [
				{k: 'I', v: msg('Receivable') + ' (AR)'},
				{k: 'R', v: msg('Payable') + ' (AP)'},
			];
		}

		if (!this.branches.has(params.parentKey)) {
			try {
				const years = this.module == 'F' ? this.years : null;
				const data = await rp.ms('analytics').get<TreeSource>(`dimensionTree/${this.module}/${this.dimNum}`, {
					parent: params.parentKey,
					accounting: this.accounting,
					years: years
				});
				data.forEach(node => node.collapsed = true);
				this.branches.set(params.parentKey, data);
			} catch (error) {
				return [
					{k: null, v: error, icon: {icon: "hexagon-exclamation", color: 'red'}}
				];
			}
		}

		return this.branches.get(params.parentKey);
	}

	getOptions(): Partial<TreeOptions> {
		return {search: true, searchKeys: true, ...this.options };
	}

}
